/**
 * Offcanvas Menu
 */
window.addEventListener("load", function () {
    let offcanvas = document.querySelector(".offcanvas");
    let btn_open_offcanvas = document.querySelector(".btn-open-offcanvas");
    let btn_close_offcanvas = document.querySelector(".btn-close-offcanvas");
    let body = document.querySelector("body");

    btn_open_offcanvas.addEventListener("click", function (e) {
        e.preventDefault();

        offcanvas.classList.add("show");
        body.classList.add("overflow-hidden");
    });

    btn_close_offcanvas.addEventListener("click", function (e) {
        e.preventDefault();

        offcanvas.classList.remove("show");
        body.classList.remove("overflow-hidden");
    });

    document.addEventListener("click", (e) => {
        let target_offcanvas =
            !e.target.parentElement.closest(".offcanvas") ?? true;
        let target_open =
            (!e.target.classList.contains("btn-open-offcanvas") &&
                !e.target.parentElement.closest(".btn-open-offcanvas")) ??
            true;

        if (target_offcanvas && target_open) {
            offcanvas.classList.remove("show");
            body.classList.remove("overflow-hidden");

            return;
        }
    });
});
